import { FC } from "react";
import { useLocation } from "react-router-dom";

import { isViewerRoute } from "../core/viewer-route";
import footerStyles from "../ui/section/footer.module.scss";
import { FullUI } from "../ui/section/full-ui";
import { Section } from "../ui/section/section";
import { Spinner } from "../ui/spinner/spinner";
import styles from "./dummy-ui.module.scss";

export interface DummyUIProps {}

export const DummyUI: FC<DummyUIProps> = ({ children }) => {
  const location = useLocation();

  return isViewerRoute(location.pathname) ? (
    <div className={styles.gameLoader}>
      {children ? <Spinner stroke="#ffffff" /> : undefined}
    </div>
  ) : (
    <FullUI>
      <Section darkBackground>{children}</Section>
      <div className={footerStyles.footer}></div>
    </FullUI>
  );
};
